export const synchronizerSchema = {
    type: 'object',
    properties: {
        requests: {
            type: 'array',
            items: { type: 'string' },
        },
        requestCategories: {
            type: 'array',
            items: { type: 'string' },
        },
    },
};

export const synchronizerSchemaExample = {
    requests: ['VAUDREUIL'],
    requestCategories: ['VAUDREUIL'],
};
